import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withKeys as _withKeys, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77aa5c0f")

_pushScopeId("data-v-77aa5c0f")
const _hoisted_1 = { class: "players__container" }
const _hoisted_2 = {
  key: 0,
  class: "player__update"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "update__title" }, [
  /*#__PURE__*/_createVNode("span", null, "Ajouter un joueur")
], -1)
const _hoisted_4 = { class: "player__card player__add" }
const _hoisted_5 = { class: "narrow__row" }
const _hoisted_6 = {
  key: 0,
  src: "/images/players/man/baseball-player.svg"
}
const _hoisted_7 = {
  key: 1,
  src: "/images/players/woman/fitness-1.svg"
}
const _hoisted_8 = {
  key: 2,
  src: "/images/players/missing_player_pic.png"
}
const _hoisted_9 = { class: "cell cell--name" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Nom: ")
const _hoisted_11 = { class: "secondnarrow__row" }
const _hoisted_12 = { class: "cell cell--gender input" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Sexe: ")
const _hoisted_14 = { class: "cell cell--number input" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Numéro # ")
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "icon-plus-circled" }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "players scrollbar--invisible"
}
const _hoisted_18 = {
  key: 0,
  src: "/images/players/man/baseball-player.svg"
}
const _hoisted_19 = {
  key: 1,
  src: "/images/players/woman/fitness-1.svg"
}
const _hoisted_20 = {
  key: 2,
  src: "/images/players/missing_player_pic.png"
}
const _hoisted_21 = { class: "cell cell--name" }
const _hoisted_22 = { class: "cell cell--number" }
const _hoisted_23 = {
  key: 3,
  class: "cell cell--edit"
}
const _hoisted_24 = {
  key: 2,
  class: "no-data"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "icon-clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, "Aucun joueur enregistré", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "tiny--text" }, [
  /*#__PURE__*/_createTextVNode("Icons made by "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://www.freepik.com",
    title: "Freepik"
  }, "Freepik"),
  /*#__PURE__*/_createTextVNode(" from "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://www.flaticon.com/",
    title: "Flaticon"
  }, "www.flaticon.com")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.canUpdateTeam)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                (_ctx.manSelected)
                  ? (_openBlock(), _createBlock("img", _hoisted_6))
                  : (_ctx.womanSelected)
                    ? (_openBlock(), _createBlock("img", _hoisted_7))
                    : (_openBlock(), _createBlock("img", _hoisted_8)),
                _createVNode("span", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newPlayerName = $event)),
                    class: "cell cell--name input",
                    type: "text",
                    tabindex: "0"
                  }, null, 512), [
                    [_vModelText, _ctx.newPlayerName]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode("span", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newPlayerGender = $event)),
                    class: "cell cell--gender input"
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.genderTypes, (type, ix) => {
                      return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(type), 1))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.newPlayerGender]
                  ])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("span", null, [
                    _hoisted_15,
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newPlayerNumber = $event)),
                      type: "number",
                      min: "0",
                      max: "99",
                      tabindex: "0"
                    }, null, 512), [
                      [_vModelText, _ctx.newPlayerNumber]
                    ])
                  ])
                ]),
                _createVNode("div", {
                  class: ["button button--action", {'button--disabled': !_ctx.playerAddValid}],
                  tabindex: "0",
                  onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addPlayer && _ctx.addPlayer(...args)), ["enter"])),
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addPlayer && _ctx.addPlayer(...args)))
                }, [
                  _hoisted_16
                ], 34)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasPlayers)
        ? (_openBlock(), _createBlock("div", _hoisted_17, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.players, (player) => {
              return (_openBlock(), _createBlock("div", {
                key: player._id,
                class: ["row player__card", {
                    'fading_row':_ctx.lastPlayerAdded(player.name)
                }]
              }, [
                (_ctx.isMan(player.gender))
                  ? (_openBlock(), _createBlock("img", _hoisted_18))
                  : (_ctx.isWoman(player.gender))
                    ? (_openBlock(), _createBlock("img", _hoisted_19))
                    : (_openBlock(), _createBlock("img", _hoisted_20)),
                _createVNode("span", _hoisted_21, _toDisplayString(player.name), 1),
                _createVNode("span", _hoisted_22, " #" + _toDisplayString(player.number), 1),
                (_ctx.canUpdateTeam)
                  ? (_openBlock(), _createBlock("span", _hoisted_23, [
                      _createVNode(_component_ConfirmAction, {
                        type: "delete",
                        onConfirm: ($event: any) => (_ctx.removePlayer(player))
                      }, null, 8, ["onConfirm"])
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_24, [
            _hoisted_25,
            _hoisted_26
          ]))
    ]),
    _hoisted_27
  ], 64))
})